module.exports = __webpack_public_path__ + "img/South Africa.1659add3.svg";